(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["margot-hero-editorial"] && !Shopify.designMode) return;
  try {
    
  function iniciarCarrosselHero(raiz) {
    (raiz || document).querySelectorAll('[data-mhe-slideshow]').forEach(function (frame) {
      if (frame.dataset.mheIniciado === 'true') return;
      var slides = frame.querySelectorAll('[data-mhe-slide]');
      if (slides.length < 2) return;
      frame.dataset.mheIniciado = 'true';

      var dots = frame.querySelectorAll('[data-mhe-dot]');
      var intervalo = parseInt(frame.dataset.interval, 10) || 5000;
      var atual = 0;
      var timer = null;

      function mostrar(indice) {
        slides[atual].classList.remove('is-active');
        if (dots[atual]) dots[atual].classList.remove('is-active');
        atual = (indice + slides.length) % slides.length;
        slides[atual].classList.add('is-active');
        if (dots[atual]) dots[atual].classList.add('is-active');
      }

      function iniciar() {
        if (timer) return;
        timer = setInterval(function () {
          mostrar(atual + 1);
        }, intervalo);
      }

      function parar() {
        clearInterval(timer);
        timer = null;
      }

      dots.forEach(function (dot, indice) {
        dot.addEventListener('click', function () {
          parar();
          mostrar(indice);
          iniciar();
        });
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) parar();
        else iniciar();
      });

      var semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!semMovimento.matches) iniciar();
    });
  }

  iniciarCarrosselHero(document);

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarCarrosselHero(evento.target);
  });

  } catch(e) { console.error(e); }
})();
})();
